import React, { FC, Fragment } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { Typography, Box, Tooltip } from '@mui/material';
import { OrderDeliveryDetails, OrderDeliveryStatus } from 'models/order';
import { currentUserVar } from 'apollo/reactive-variables/user';

type DeliveryAndDeadlineDetailsProps = {
    details: OrderDeliveryDetails;
    /** The production deadline is the supplier's own; a lab that placed the order sees only the delivery date (DD-3689). */
    showDeadline?: boolean;
};
const DeliveryAndDeadlineDetails: FC<DeliveryAndDeadlineDetailsProps> = ({
    details,
    showDeadline = true,
}: DeliveryAndDeadlineDetailsProps) => {
    const currentUser = currentUserVar();
    const { t: translate } = useTranslation(['orders', 'milling-jobs']);
    const shouldDisplayDelayed = currentUser.viewSettings?.deliveryDatePassed || false;

    return (
        <Fragment>
            <Box mr={0.5} sx={{ whiteSpace: 'nowrap' }}>
                {details.date && details.status === OrderDeliveryStatus.DELAYED && shouldDisplayDelayed ? (
                    <Tooltip title={translate('orders:DELIVERY_STATUS_DELAYED').toString()}>
                        <Typography variant="body2" sx={{ color: 'error.main' }}>
                            {formatDate(new Date(details.date), 'date')}
                        </Typography>
                    </Tooltip>
                ) : (
                    formatDate(new Date(details.date), 'date')
                )}
            </Box>
            {!showDeadline ? undefined : details.internalDeliveryDate &&
              details.deadlineStatus === OrderDeliveryStatus.DELAYED ? (
                <Tooltip title={translate('orders:DELIVERY_STATUS_DELAYED').toString()}>
                    <Typography variant="body2" sx={{ color: 'error.main' }}>
                        {formatDate(details.internalDeliveryDate, 'date')}
                    </Typography>
                </Tooltip>
            ) : details.internalDeliveryDate ? (
                formatDate(details.internalDeliveryDate, 'date')
            ) : (
                translate('milling-jobs:NO_DEADLINE')
            )}
        </Fragment>
    );
};

export default DeliveryAndDeadlineDetails;
